const Campeonatos = () => {
  // Lista con todos los campeonatos de Quimsa masculino y femenino
  const campeonatos = [
    // Masculino - Nacionales
    {
      id: 1,
      titulo: "Liga Nacional de Básquet (LNB) 2014/15",
      descripcion:
        "Primer título de Quimsa en la Liga Nacional de Básquet, consagrándose campeón tras una temporada histórica.",
      imagen:
        "https://www.laliganacional.com.ar/uploadsfotos/campeones_grafica_liga_nacional_quimsa.jpg",
      colorBorde: "border-blue-900",
      colorTexto: "text-blue-900",
    },
    {
      id: 2,
      titulo: "Liga Nacional de Básquet (LNB) 2022/23",
      descripcion:
        "Quimsa reafirmó su dominio nacional con su segundo campeonato de Liga Nacional en la temporada 2022/23.",
      imagen:
        "https://www.laliganacional.com.ar/uploadsfotos/rwerwrw.jpg",
      colorBorde: "border-blue-900",
      colorTexto: "text-blue-900",
    },
    {
      id: 3,
      titulo: "Copa Argentina 2009",
      descripcion:
        "Quimsa obtuvo la Copa Argentina, mostrando su crecimiento en competencias nacionales.",
      imagen:
        "https://www.diariopanorama.com/fotos/notas/2018/12/23/308344_20181223005235.jpg",
      colorBorde: "border-red-600",
      colorTexto: "text-red-600",
    },
    {
      id: 4,
      titulo: "Torneo Súper 8 2014",
      descripcion:
        "Campeones del Torneo Súper 8, sumando otro título nacional a su palmarés.",
      imagen:
        "https://www.diariopanorama.com/fotos/notas/2018/12/23/308344_20181223005143.jpg",
      colorBorde: "border-red-600",
      colorTexto: "text-red-600",
    },
    {
      id: 5,
      titulo: "Copa Súper 20 (2018, 2020)",
      descripcion:
        "Quimsa ganó dos ediciones de la Copa Súper 20, consolidándose como uno de los equipos más competitivos.",
      imagen:
        "https://www.ole.com.ar/2024/03/15/RUAg89Vro_720x0__1.jpg",
      colorBorde: "border-yellow-400",
      colorTexto: "text-yellow-600",
    },
    {
      id: 6,
      titulo: "Supercopa de La Liga (2021, 2023)",
      descripcion:
        "Dos títulos más en la Supercopa, reflejo de la consistencia y calidad del equipo.",
      imagen:
        "https://www.unocontraunoweb.com/wp-content/uploads/2023/12/Supercopa-de-La-Liga-2023-Quimsa-v-Gimnasia-CR-1-scaled.jpg",
      colorBorde: "border-blue-700",
      colorTexto: "text-blue-700",
    },

    // Masculino - Internacionales
    {
      id: 7,
      titulo: "Liga Sudamericana de Clubes 2009",
      descripcion:
        "Quimsa conquistó su primer título internacional con la Liga Sudamericana de Clubes.",
      imagen:
        "https://www.diariopanorama.com/fotos/notas/2018/12/23/308344_20181223005210.jpg",
      colorBorde: "border-green-600",
      colorTexto: "text-green-600",
    },
    {
      id: 8,
      titulo: "Basketball Champions League Americas (BCLA) 2020",
      descripcion:
        "El título más importante a nivel continental. Quimsa se consagró campeón de la Basketball Champions League Americas en una final histórica.",
      imagen:
        "https://media.tycsports.com/files/2020/10/30/131089/quimsa-.jpg",
      colorBorde: "border-yellow-400",
      colorTexto: "text-yellow-600",
    },
    {
      id: 9,
      titulo: "Basketball Champions League Americas (BCLA) 2024",
      descripcion:
        "Repitiendo la hazaña continental, Quimsa ganó nuevamente la BCLA en 2024, reafirmando su jerarquía.",
      imagen:
        "https://resizer.glanacion.com/resizer/v2/quimsa-se-corono-campeon-de-america-por-segunda-66TYFH34NNHR3E6YJLPLPEAAYI.jpg?auth=07cf9c1de3bb6dc442214db45b0ffb470a2b1ac702f77f8937ad53b94c369a71&width=1280&height=854&quality=70&smart=true",
      colorBorde: "border-yellow-400",
      colorTexto: "text-yellow-600",
    },

    // Femenino - Nacionales
    {
      id: 10,
      titulo: "Liga Femenina de Básquetbol 2018",
      descripcion:
        "El equipo femenino de Quimsa se consagró campeón de la Liga Femenina, marcando un hito en su historia.",
      imagen:
        "https://www.argentina.basketball/themes/ee/site/default/asset/img/blog/dsc_6500_jx_bh.jpg",
      colorBorde: "border-pink-500",
      colorTexto: "text-pink-600",
    },
    {
      id: 11,
      titulo: "Liga Femenina de Básquetbol 2019",
      descripcion:
        "Revalidando su poderío, Quimsa logró el bicampeonato en la Liga Femenina.",
      imagen:
        "https://www.laliganacional.com.ar/uploadsfotos/dsc_1104_0e_bo.jpg",
      colorBorde: "border-pink-500",
      colorTexto: "text-pink-600",
    },
    {
      id: 12,
      titulo: "Supercopa de la Liga Femenina 2019",
      descripcion:
        "Quimsa también se coronó campeón de la Supercopa femenina, agregando otro título importante.",
      imagen:
        "https://doblesytriples.com.ar/wp-content/uploads/2019/03/Quimsa-campeon-773x380.jpeg",
      colorBorde: "border-pink-400",
      colorTexto: "text-pink-600",
    },

    // Otros (ejemplo: Subcampeón)

  ];

  return (
    <main className="bg-[#202C5A] min-h-screen text-white py-12">
      <section className="max-w-6xl mx-auto px-6">
        <h1 className="text-4xl font-bold mb-8 border-b-2 border-white pb-2 uppercase text-white inline-block">
          Campeonatos
        </h1>

        <p className="text-lg leading-relaxed mb-10 max-w-3xl text-white/90">
          Quimsa ha escrito páginas doradas en el básquet nacional e internacional. Desde títulos continentales hasta conquistas locales, cada campeonato refleja el esfuerzo, la entrega y la pasión de todo el club.
        </p>

        <div className="grid md:grid-cols-2 gap-8">
          {campeonatos.map(({ id, titulo, descripcion, imagen, colorBorde, colorTexto }) => (
            <div
              key={id}
              className={`relative overflow-hidden rounded-xl shadow-xl border-2 ${colorBorde} bg-white/5 group transition-transform hover:scale-105`}
              style={{ minHeight: 350 }}
            >
              {/* Imagen de fondo con overlay en hover */}
              <img
                src={imagen}
                alt={titulo}
                className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-100 transition duration-300"
              />
              {/* Overlay oscuro para contraste */}
              <div className="absolute inset-0 bg-[#202C5A] bg-opacity-50 group-hover:bg-opacity-20 transition duration-300" />
              
              {/* Contenido encima */}
              <div className="relative z-10 flex flex-col justify-end h-full p-6">
                <h2
                  className={`text-2xl md:text-3xl font-bold mb-2 uppercase tracking-tight border-l-4 pl-3 ${colorBorde} ${colorTexto} drop-shadow`}
                  style={{ background: "rgba(32,44,90,0.8)" }}
                >
                  {titulo}
                </h2>
                <p
                  className="text-white/90 text-base md:text-lg mt-2 p-3 rounded bg-[#202C5A]/60 shadow"
                  style={{ backdropFilter: "blur(2px)" }}
                >
                  {descripcion}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Campeonatos;